import { render, staticRenderFns } from "./ProcessRequestSlidebar.vue?vue&type=template&id=3d710e78"
import script from "./ProcessRequestSlidebar.vue?vue&type=script&lang=js"
export * from "./ProcessRequestSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports